import { ComponentPropsWithoutRef, ComponentType } from 'react';

import classNames from 'classnames';

import CreditCard from '@uikit/icons/CreditCard';
import CurrencyExchange from '@uikit/icons/CurrencyExchange';
import Gamepad from '@uikit/icons/Gamepad';
import Group from '@uikit/icons/Group';
import Nft from '@uikit/icons/Nft';
import RepairCase from '@uikit/icons/RepairCase';

import { ComponentWrapperElementType } from '../../../utils/types';

interface AppCategoryProps extends ComponentPropsWithoutRef<'span'> {
  category: string;
  hideIcon?: boolean;
  subCategory?: string;
  Component?: ComponentWrapperElementType;
}

const categoryIconName: Record<string, ComponentType> = {
  Gaming: Gamepad,
  Metaverse: Gamepad,
  Games: Gamepad,
  Exchanges: CurrencyExchange,
  Finance: CreditCard,
  DeFi: CreditCard,
  NFT: Nft,
  'Social media': Group,
  Media: Group,
  Utilities: RepairCase,
};

const getAppCategoryIcon = (category: string) => {
  return categoryIconName[category];
};

const AppCategory = ({
  category,
  hideIcon,
  className,
  subCategory,
  Component = 'span',
  ...props
}: AppCategoryProps) => {
  const SpecificIcon = getAppCategoryIcon(category);

  return (
    <Component
      className={classNames('inline-flex items-center gap-0.5', className)}
      {...props}
      data-qa="info-category"
    >
      {!hideIcon && SpecificIcon && (
        <span className="icon-xs relative mr-2 align-baseline">
          <SpecificIcon />
        </span>
      )}
      {category}

      {subCategory && (
        <>
          <svg
            width="8"
            height="4"
            viewBox="0 0 8 8"
            xmlns="http://www.w3.org/2000/svg"
            fill="#CECDD6"
          >
            <circle
              cx="13.74"
              cy="4"
              r="4"
              transform="translate(-9.74)"
              fillRule="evenodd"
            ></circle>
          </svg>
          {subCategory}
        </>
      )}
    </Component>
  );
};

export default AppCategory;
